
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import { mapState, mapGetters, mapActions } from 'vuex';
import ThumbnailShape from '@/enums/ThumbnailShape';

export default {
  i18nComponentKey: 'WidgetReviewsGallery.components.Gallery',
  name: 'Gallery',
  mixins: [PaginatedReviewResourceView],
  props: {
    cols: {
      type: Number,
      required: true
    },
    gutter: {
      type: Number,
      required: true
    },
    productImageSize: {
      type: Number,
      required: true
    },
    rowGap: {
      type: Number,
      default: 32
    }
  },
  computed: {
    ...mapState(['brandCode']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    ...mapState('widget', ['isMobile']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'device',
      'headerSectionShowable',
      'showFilterSection',
      'thumbnailShape'
    ]),
    productThumbnailType() {
      return this.widget.product_thumbnail_shape === ThumbnailShape.SQUARE
        ? 'rounded'
        : 'circle';
    },
    styleProps() {
      const { background_color, layout_column, column_gap } = this.widget;
      return {
        backgroundColor: background_color,
        '--layout-column': layout_column,
        '--column-gap': column_gap ? `${column_gap}px` : ''
      };
    },
    minCardWidth() {
      return this.device === 'pc' ? 100 : 0;
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
